import { render, staticRenderFns } from "./StyleEditorClass.vue?vue&type=template&id=2dd3c2f0&"
import script from "./StyleEditorClass.vue?vue&type=script&lang=ts&"
export * from "./StyleEditorClass.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports